<div class="backpage-wrapper slide-in">
  <div class="onboarding-form-content-creator">
    <ng-container *ngIf="isOnboardingExternalUser"
      ><div class="external-role-error-container padding s6 all">
        <phx-card class="left-side-card padding s6 all">
          <img
            width="75"
            height="75"
            src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
            alt="orange explanation point"
          />
          <h2>
            Your account is not tied to an external role - contact
            <a href="mailto:mobilecredentials@allegion.com"
              >mobilecredentials&#64;allegion.com</a
            >
            and Allegion will help you complete setup.
          </h2>
        </phx-card>
        <div class="view-info-button-container padding s6 all"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="isOnboardingInternalUser">
      <div class="onboarding-form-container padding s8 all">
        <div class="header">
          <h1>{{ "Onboarding.OnboardingForm" | translate }}</h1>
        </div>
        <!-- <div> -->
        <div
          *ngIf="isOnboardingInternalUser"
          class="onboarding-form margin s6 all"
        >
          <form [formGroup]="onboardingForm">
            <div class="search">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="company-search"
              >
                <mat-label>Company Search</mat-label>
                <input
                  matInput
                  [formControl]="companySearchControl"
                  [matAutocomplete]="auto"
                  placeholder="Enter company name..."
                  (input)="getAccounts(companySearchControl.value)"
                />

                <mat-autocomplete
                  #auto="matAutocomplete"
                  [displayWith]="displayAccountName.bind(this)"
                  (optionSelected)="
                    onboardingForm.controls['accountId'].setValue(
                      $event.option.value.accountId
                    );
                    selectedAccountSubType =
                      $event.option.value.accountSubType || null
                  "
                >
                  <mat-option
                    *ngFor="let option of filteredOptions | async"
                    [value]="option"
                  >
                    {{ option.businessId }} (Account #{{
                      option.accountNumber || "N/A"
                    }})
                    <br />
                    <!-- {{ option.addressCity }}, {{ option.addressState }} -->
                  </mat-option>
                  <mat-option
                    *ngIf="(filteredOptions | async)?.length === 0 && !itemData"
                    disabled
                  >
                    No accounts found
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              @if (selectedAccountSubType) {
              <div class="account-subtype-badge">
                <span class="account-subtype-label">Account Sub Type:</span>
                <span class="account-subtype-value">{{
                  selectedAccountSubType
                }}</span>
              </div>
              }
            </div>
            <div class="radio-button-section flex flex-column">
              <div class="select-product-header">
                <h3 class="mat-headline Selection">
                  {{ "Onboarding.SelectProduct" | translate }}
                </h3>
                <span
                  class="price-table-trigger"
                  [matMenuTriggerFor]="priceMenu"
                  matTooltip="View credential pricing"
                >
                  <mat-icon>info_outline</mat-icon> Price Table
                </span>
              </div>

              <mat-menu #priceMenu="matMenu" class="price-table-menu">
                <div
                  class="price-table-container"
                  (click)="$event.stopPropagation()"
                >
                  <h4>Credential Pricing - Account SubTypes</h4>
                  <ng-container
                    *ngIf="
                      credentialPricing$ | async as pricing;
                      else loadingPrices
                    "
                  >
                    <table class="price-table">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>SKU</th>
                          <th *ngFor="let col of pricing.customerTypes">
                            {{ col }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of pricing.rows">
                          <td>{{ row.type }}</td>
                          <td>{{ row.sku }}</td>
                          <td *ngFor="let col of pricing.customerTypes">
                            {{ row[col] }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                  <ng-template #loadingPrices>
                    <p class="loading-text">Loading prices...</p>
                  </ng-template>
                </div>
              </mat-menu>
              <!--1.Engage 2.APICred 3.EB 4.SI 5.RK (product values to send to API)-->
              <mat-radio-group class="radioButtons" formControlName="product">
                <!-- API RADIO BUTTON -->
                <mat-radio-button [value]="2">API Credentials</mat-radio-button>
                <!-- EB Radio Button -->
                <mat-radio-button [value]="3">Employee Badge</mat-radio-button>
                <!-- SI Radio Button -->
                <mat-radio-button [value]="4">StudentID</mat-radio-button>
                <!-- RK Radio Button -->
                <mat-radio-button [value]="5">Resident Key</mat-radio-button>
              </mat-radio-group>
              <div
                *ngIf="
                  companySearchControl.invalid &&
                  (companySearchControl.touched || companySearchControl.dirty)
                "
                class="error"
              >
                Please select one of the options.
              </div>
              <!-- Additional API inputs -->
              <div *ngIf="onboardingForm.get('product')?.value == 2">
                <div class="additional-radio-buttons">
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Integration Name</mat-label>
                    <input
                      matInput
                      formControlName="integrationName"
                      placeholder="Integration Friendly Name..."
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Integration ID</mat-label>
                    <input
                      matInput
                      [pattern]="
                        '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
                      "
                      formControlName="integrationId"
                      placeholder="Enter ID..."
                    />
                    <mat-error
                      *ngIf="
                        this.onboardingForm.controls['integrationId'].invalid &&
                        (this.onboardingForm.controls['integrationId']
                          .touched ||
                          this.onboardingForm.controls['integrationId'].dirty)
                      "
                    >
                      Letters, Numbers, and Hyphens only
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Billing Anniversary Date</mat-label>
                    <input
                      matInput
                      formControlName="anniversaryDate"
                      [matDatepicker]="picker"
                      placeholder="MM/DD/YYYY..."
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <div class="toggle-fields">
                    <mat-slide-toggle formControlName="isLiveClientSite">
                      Is Live Site
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="invoiceToCustomer">
                      Invoice to Customer
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="initialPoRequired">
                      Initial PO Required
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
              <!-- end API endpoints -->

              <!-- Additional EB inputs -->
              <div *ngIf="onboardingForm.get('product')?.value == 3">
                <div class="additional-radio-buttons">
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Integration Name</mat-label>
                    <input
                      matInput
                      formControlName="integrationName"
                      placeholder="Integration Friendly Name..."
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Integration ID</mat-label>
                    <input
                      matInput
                      [pattern]="
                        '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
                      "
                      formControlName="integrationId"
                      placeholder="Enter ID..."
                    />
                    <mat-error
                      *ngIf="
                        this.onboardingForm.controls['integrationId'].invalid &&
                        (this.onboardingForm.controls['integrationId']
                          .touched ||
                          this.onboardingForm.controls['integrationId'].dirty)
                      "
                    >
                      Letters, Numbers, and Hyphens only
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Billing Anniversary Date</mat-label>
                    <input
                      matInput
                      formControlName="anniversaryDate"
                      [matDatepicker]="picker"
                      placeholder="MM/DD/YYYY..."
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <div class="toggle-fields">
                    <mat-slide-toggle formControlName="isLiveClientSite">
                      Is Live Site
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="invoiceToCustomer">
                      Invoice to Customer
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="initialPoRequired">
                      Initial PO Required
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
              <!-- end EB endpoints -->

              <!-- Additional SI inputs -->
              <div *ngIf="onboardingForm.get('product')?.value == 4">
                <div class="additional-radio-buttons">
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Integration Name</mat-label>
                    <input
                      matInput
                      formControlName="integrationName"
                      placeholder="Integration Friendly Name..."
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Integration ID</mat-label>
                    <input
                      matInput
                      [pattern]="
                        '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
                      "
                      formControlName="integrationId"
                      placeholder="Enter ID..."
                    />
                    <mat-error
                      *ngIf="
                        this.onboardingForm.controls['integrationId'].invalid &&
                        (this.onboardingForm.controls['integrationId']
                          .touched ||
                          this.onboardingForm.controls['integrationId'].dirty)
                      "
                    >
                      Letters, Numbers, and Hyphens only
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Billing Anniversary Date</mat-label>
                    <input
                      matInput
                      formControlName="anniversaryDate"
                      [matDatepicker]="picker"
                      placeholder="MM/DD/YYYY..."
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <div class="toggle-fields">
                    <mat-slide-toggle formControlName="isLiveClientSite">
                      Is Live Site
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="invoiceToCustomer">
                      Invoice to Customer
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="initialPoRequired">
                      Initial PO Required
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
              <!-- end SI endpoints -->
              <!-- Additional RK inputs -->
              <div *ngIf="onboardingForm.get('product')?.value == 5">
                <div class="additional-radio-buttons">
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Integration Name</mat-label>
                    <input
                      matInput
                      formControlName="integrationName"
                      placeholder="Integration Friendly Name..."
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Integration ID</mat-label>
                    <input
                      matInput
                      [pattern]="
                        '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
                      "
                      formControlName="integrationId"
                      placeholder="Enter ID..."
                    />
                    <mat-error
                      *ngIf="
                        this.onboardingForm.controls['integrationId'].invalid &&
                        (this.onboardingForm.controls['integrationId']
                          .touched ||
                          this.onboardingForm.controls['integrationId'].dirty)
                      "
                    >
                      Letters, Numbers, and Hyphens only
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Billing Anniversary Date</mat-label>
                    <input
                      matInput
                      formControlName="anniversaryDate"
                      [matDatepicker]="picker"
                      placeholder="MM/DD/YYYY..."
                    />
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <div class="toggle-fields">
                    <mat-slide-toggle formControlName="isLiveClientSite">
                      Is Live Site
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="invoiceToCustomer">
                      Invoice to Customer
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="initialPoRequired">
                      Initial PO Required
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
              <!-- end RK endpoints -->
            </div>
            <div class="notes-section">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="notes-input"
              >
                <mat-label>Notes</mat-label>
                <input
                  matInput
                  placeholder="Enter any comments/notes..."
                  formControlName="notes"
                />
                <mat-hint>*Optional*</mat-hint>
              </mat-form-field>
            </div>
            <div *ngIf="apiErrorMessage" class="api-error-message">
              {{ apiErrorMessage }}
            </div>
            <div class="button-section">
              <button mat-flat-button color="accent" (click)="clearForm()">
                {{ "Onboarding.Clear" | translate }}
              </button>
              <button
                mat-flat-button
                color="primary"
                (click)="submitOnboardingForm()"
                [disabled]="!onboardingForm.valid"
              >
                {{ "Onboarding.Submit" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <!-- </div> -->
    </ng-container>
  </div>
</div>

<!-- <div class="backpage-wrapper">
  <div class="backpage" >
    <div class="flex flex-space-between align-items-center">
      <h2 class="page-header mat-headline">
        {{ "Onboarding.OnboardingForm" | translate }}
      </h2>
    </div>
    <hr />

    <div class="no-company-text" *ngIf="isOnboardingExternalUser">
      <h2>
        Your account is not tied to an external role - contact
        <a href="mailto:mobilecredentials@allegion.com"
          >mobilecredentials&#64;allegion.com</a
        >
        and Allegion will help you complete setup.
      </h2>
    </div>
    <div class="flex flex-column" *ngIf="isOnboardingInternalUser">
      <div class="flex">
        <div class="onboarding-main onboarding-form-section">
          <div class="onboarding-main-page-title mat-headline">
            <h2 *ngIf="isOnboardingInternalUser" class="mat-headline">
              {{ "Onboarding.OnboardingInfo" | translate }}
            </h2>
          </div>
          <div>
            <div *ngIf="isOnboardingInternalUser" class="example-container">
              <form [formGroup]="onboardingForm">
                <div class="search">
                  <mat-form-field
                    appearance="outline"
                    floatLabel="always"
                    class="company-search"
                  >
                    <mat-label>Company Search</mat-label>
                    <input
                      matInput
                      [formControl]="companySearchControl"
                      [matAutocomplete]="auto"
                      placeholder="Enter company name..."
                      (input)="getAccounts(companySearchControl.value)"
                    /> -->

<!-- <mat-autocomplete
                      #auto="matAutocomplete"
                      [displayWith]="displayAccountName.bind(this)"
                      (optionSelected)="
                        onboardingForm.controls['accountId'].setValue(
                          $event.option.value.accountId
                        )
                      "
                    >
                      <mat-option
                        *ngFor="let option of filteredOptions | async"
                        [value]="option"
                      >
                        {{ option.businessId }} (Account #{{
                          option.accountNumber || "N/A"
                        }})
                        <br /> -->
<!-- {{ option.addressCity }}, {{ option.addressState }} -->
<!-- </mat-option>
                      <mat-option
                        *ngIf="
                          (filteredOptions | async)?.length === 0 && !itemData
                        "
                        disabled
                      >
                        No accounts found
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="radio-button-section flex flex-column">
                  <h3 class="mat-headline Selection">
                    {{ "Onboarding.SelectProduct" | translate }}
                  </h3> -->
<!--1.Engage 2.APICred 3.EB 4.SI 5.RK (product values to send to API)-->
<!-- <mat-radio-group
                    class="radioButtons"
                    formControlName="product"
                  > -->
<!-- API RADIO BUTTON -->
<!-- <mat-radio-button [value]="2"
                      >API Credentials</mat-radio-button
                    > -->
<!-- EB Radio Button -->
<!-- <mat-radio-button [value]="3"
                      >Employee Badge</mat-radio-button
                    > -->
<!-- SI Radio Button -->
<!-- <mat-radio-button [value]="4">StudentID</mat-radio-button> -->
<!-- RK Radio Button -->
<!-- <mat-radio-button [value]="5"
                      >Resident Key</mat-radio-button
                    >
                  </mat-radio-group>
                  <div
                    *ngIf="
                      companySearchControl.invalid &&
                      (companySearchControl.touched ||
                        companySearchControl.dirty)
                    "
                    class="error"
                  >
                    Please select one of the options.
                  </div> -->
<!-- Additional API inputs -->
<!-- <div *ngIf="onboardingForm.get('product')?.value == 2">
                    <div class="additional-radio-buttons">
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Integration Name</mat-label>
                        <input
                          matInput
                          formControlName="integrationName"
                          placeholder="Integration Friendly Name..."
                        />
                      </mat-form-field>
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Integration ID</mat-label>
                        <input
                          matInput
                          [pattern]="
                            '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
                          "
                          formControlName="integrationId"
                          placeholder="Enter ID..."
                        />
                        <mat-error
                          *ngIf="
                            this.onboardingForm.controls['integrationId']
                              .invalid &&
                            (this.onboardingForm.controls['integrationId']
                              .touched ||
                              this.onboardingForm.controls['integrationId']
                                .dirty)
                          "
                        >
                          Letters, Numbers, and Hyphens only
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Billing Anniversary Date</mat-label>
                        <input
                          matInput
                          formControlName="anniversaryDate"
                          [matDatepicker]="picker"
                          placeholder="MM/DD/YYYY..."
                        />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div> -->
<!-- end API endpoints -->

<!-- Additional EB inputs -->
<!-- <div *ngIf="onboardingForm.get('product')?.value == 3">
                    <div class="additional-radio-buttons">
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Integration Name</mat-label>
                        <input
                          matInput
                          formControlName="integrationName"
                          placeholder="Integration Friendly Name..."
                        />
                      </mat-form-field>
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Integration ID</mat-label>
                        <input
                          matInput
                          [pattern]="
                            '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
                          "
                          formControlName="integrationId"
                          placeholder="Enter ID..."
                        />
                        <mat-error
                          *ngIf="
                            this.onboardingForm.controls['integrationId']
                              .invalid &&
                            (this.onboardingForm.controls['integrationId']
                              .touched ||
                              this.onboardingForm.controls['integrationId']
                                .dirty)
                          "
                        >
                          Letters, Numbers, and Hyphens only
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Billing Anniversary Date</mat-label>
                        <input
                          matInput
                          formControlName="anniversaryDate"
                          [matDatepicker]="picker"
                          placeholder="MM/DD/YYYY..."
                        />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div> -->
<!-- end EB endpoints -->

<!-- Additional SI inputs -->
<!-- <div *ngIf="onboardingForm.get('product')?.value == 4">
                    <div class="additional-radio-buttons">
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Integration Name</mat-label>
                        <input
                          matInput
                          formControlName="integrationName"
                          placeholder="Integration Friendly Name..."
                        />
                      </mat-form-field>
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Integration ID</mat-label>
                        <input
                          matInput
                          [pattern]="
                            '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
                          "
                          formControlName="integrationId"
                          placeholder="Enter ID..."
                        />
                        <mat-error
                          *ngIf="
                            this.onboardingForm.controls['integrationId']
                              .invalid &&
                            (this.onboardingForm.controls['integrationId']
                              .touched ||
                              this.onboardingForm.controls['integrationId']
                                .dirty)
                          "
                        >
                          Letters, Numbers, and Hyphens only
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Billing Anniversary Date</mat-label>
                        <input
                          matInput
                          formControlName="anniversaryDate"
                          [matDatepicker]="picker"
                          placeholder="MM/DD/YYYY..."
                        />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div> -->
<!-- end SI endpoints -->
<!-- Additional RK inputs -->
<!-- <div *ngIf="onboardingForm.get('product')?.value == 5">
                    <div class="additional-radio-buttons">
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Integration Name</mat-label>
                        <input
                          matInput
                          formControlName="integrationName"
                          placeholder="Integration Friendly Name..."
                        />
                      </mat-form-field>
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Integration ID</mat-label>
                        <input
                          matInput
                          [pattern]="
                            '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$'
                          "
                          formControlName="integrationId"
                          placeholder="Enter ID..."
                        />
                        <mat-error
                          *ngIf="
                            this.onboardingForm.controls['integrationId']
                              .invalid &&
                            (this.onboardingForm.controls['integrationId']
                              .touched ||
                              this.onboardingForm.controls['integrationId']
                                .dirty)
                          "
                        >
                          Letters, Numbers, and Hyphens only
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" floatLabel="always">
                        <mat-label>Billing Anniversary Date</mat-label>
                        <input
                          matInput
                          formControlName="anniversaryDate"
                          [matDatepicker]="picker"
                          placeholder="MM/DD/YYYY..."
                        />
                        <mat-datepicker-toggle
                          matIconSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div> -->
<!-- end RK endpoints -->
<!-- </div>
                <div class="notes-section">
                  <mat-form-field
                    appearance="outline"
                    floatLabel="always"
                    class="notes-input"
                  >
                    <mat-label>Notes</mat-label>
                    <input
                      matInput
                      placeholder="Enter any comments/notes..."
                      formControlName="notes"
                    />
                    <mat-hint>*Optional*</mat-hint>
                  </mat-form-field>
                </div>
                <div class="button-section">
                  <button mat-flat-button color="accent" (click)="clearForm()">
                    {{ "Onboarding.Clear" | translate }}
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="submitOnboardingForm()"
                    [disabled]="!onboardingForm.valid"
                  >
                    {{ "Onboarding.Submit" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
